import BaseCtrl from 'edge/platform/base/BaseCtrl';
import { PhoneNumberUtil } from 'libphonenumber';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import nameUtil from 'edge/gateway/util/NameUtil';
import transcludeContent from 'text!edge/gateway/views/renewal/renewal-modal-withdraw.html';

var fn = function fn($scope, $state, lobConfig, $window, $q, $stateParams, RenewalService, ActivityService, $modal, ModalService, $filter, UserService, $translate, InsuranceSuiteMetadata, defaultLocaleDetails, GPA_PC_ENTRY_POINT) {

    var phoneUtils = PhoneNumberUtil.getInstance();
    var SupportedTransactionLOBs = ['BOPLine', 'CPLine'];
    var ctrl = Object.create(BaseCtrl);

    var customerRequestOption = {
        id: 'customerRequestOption',
        value: 'customerRequestOption',
        label: 'gateway.controllers.renewal.RenewalDetailCtrl.Customer Request',
        description: {
            mainText: 'gateway.controllers.renewal.RenewalDetailCtrl.The customer has decided to decline the renewal of the policy.'
        }
    };

    var insurerRequestOption = {
        id: 'insurerRequestOption',
        value: 'insurerRequestOption',
        label: 'gateway.controllers.renewal.RenewalDetailCtrl.Insurer Request',
        description: {
            mainText: 'gateway.controllers.renewal.RenewalDetailCtrl.It has been decided not to allow renewal of this policy.'
        }
    };

    ctrl.init = function () {
        var applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.gatewayQuote = applicationFeatures.gatewayquoteandbind === 'true';
        $scope.renewalNumber = $stateParams.renewalNumber;

        $scope.loadingRenewalPromise = RenewalService.findJobByJobNumber($stateParams.renewalNumber).then(function (renewal) {
            if (!renewal.statusCode) {
                ModalService.showError('gateway.directives.JobSummary.Error', 'gateway.directives.JobSummary.Error.Details');
                $state.go('policies.index');
            }
            $scope.renewal = renewal;

            $scope.accountInfo = {};
            $scope.latestPeriod = renewal.policy.latestPeriod;
            $scope.renewalPeriod = renewal.latestPeriod;
            $scope.policyNumber = renewal.policy.policyNumber;
            $scope.createTime = renewal.createTime;

            mapAccountDetails(renewal.policy.account);

            if ($scope.renewal.statusCode === 'NotTaken') {
                $scope.isNotTaken = true;
            }

            initCloseOptions();
        }, function () {
            ModalService.showError('gateway.directives.JobSummary.Error', 'gateway.directives.JobSummary.Error.Details');
            $state.go('policies.index');
        });

        updateSummaryFromServer();
    };

    function initCloseOptions() {
        $scope.hasOptions = false;
        $scope.options = [];

        if ($scope.renewal.canPendingNonRenew) {
            $scope.options.push(customerRequestOption);
            $scope.hasOptions = true;
        }

        if ($scope.renewal.canPendingNotTaken) {
            $scope.options.push(insurerRequestOption);
            $scope.hasOptions = true;
        }
    }

    function mapAccountDetails(accountDetails) {
        if (!accountDetails) {
            return;
        }

        $scope.accountInfo.publicID = accountDetails.publicID;
        $scope.accountInfo.policySummaries = accountDetails.policySummaries;
        $scope.accountInfo.accountNumber = accountDetails.accountNumber;
        $scope.accountInfo.canCreateSub = accountDetails.canUserCreateRenewal;

        setupAccountContactDetails(accountDetails.accountHolder);
    }

    function setupAccountContactDetails(accountHolder) {
        $scope.accountInfo.subtype = accountHolder.subtype;
        if (accountHolder.subtype === 'Person') {
            $scope.accountInfo.firstName = accountHolder.firstName;
            $scope.accountInfo.lastName = accountHolder.lastName;
            $scope.accountInfo.contactName = nameUtil.getDisplayName(accountHolder, ' ');
        } else {
            $scope.accountInfo.contactName = accountHolder.contactName;
        }

        $scope.accountInfo.primaryAddress = accountHolder.primaryAddress;

        if (accountHolder.primaryPhoneType === 'work' && angular.isDefined(accountHolder.workNumber) && accountHolder.workNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.workNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'home' && angular.isDefined(accountHolder.homeNumber) && accountHolder.homeNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.homeNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'mobile' && angular.isDefined(accountHolder.cellNumber) && accountHolder.cellNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.cellNumber, defaultLocaleDetails.countryCode));
        }
    }

    ctrl.continueRenewal = function () {
        if (SupportedTransactionLOBs.includes($scope.renewal.policy.latestPeriod.policyLines[0].lineOfBusinessCode)) {
            $state.transitionTo('renewalTransactionEntry', {
                selectedRenewal: $scope.renewalNumber
            });
        } else {
            // Redirect to PolicyCenter EntryPoint to continue new renewal
            $window.location.href = GPA_PC_ENTRY_POINT + '?JobNumber=' + $scope.renewalNumber;
        }
    };

    ctrl.withdrawRenewal = function () {
        var renewalNumber = $scope.renewalNumber;
        var modalPromise = ModalService.showWarning($scope.hasOptions ? 'gateway.controllers.renewal.RenewalDetailCtrl.Reason for Cancelling the Renewal' : 'gateway.controllers.renewal.RenewalDetailCtrl.Withdraw the Renewal?', $scope.hasOptions ? undefined : 'gateway.controllers.renewal.RenewalDetailCtrl.Are you sure you want to withdraw the Renewal?', undefined, $scope.hasOptions ? $filter('translate')('gateway.controllers.renewal.RenewalDetailCtrl.Cancel Renewal') : $filter('translate')('gateway.controllers.renewal.RenewalDetailCtrl.Withdraw Renewal'), undefined, $scope.hasOptions ? $filter('translate')('gateway.controllers.renewal.RenewalDetailCtrl.Do Not Cancel') : $filter('translate')('gateway.controllers.renewal.RenewalDetailCtrl.Do Not Withdraw'), $scope.options, $scope.hasOptions ? transcludeContent : undefined).result;

        modalPromise.then(function (optionsModel) {
            var jobPromise = void 0;
            var jobStatusCode = 'Withdrawn';
            if (optionsModel) {
                if (optionsModel.code.code === customerRequestOption.value) {
                    jobPromise = RenewalService.markRenewalNotTaken(renewalNumber);
                    jobStatusCode = 'NotTaking';
                } else if (optionsModel.code.code === insurerRequestOption.value) {
                    jobPromise = RenewalService.markRenewalNonRenew(renewalNumber);
                    jobStatusCode = 'NonRenewing';
                }
            } else {
                jobPromise = RenewalService.withdrawRenewalByRenewalNumber(renewalNumber);
            }

            jobPromise.then(function () {
                var status = InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode(jobStatusCode);
                $scope.renewal.status = status.name;
                $scope.renewalStatusString = status.name;
                $scope.renewal.statusCode = status.code;
                // reset options once successful cancellation has been processed
                $scope.options = [];
                $scope.hasOptions = false;
            }, function () {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.renewal.renewal-summary.Failed to cancel renewal.');
            });
        });
    };

    function updateSummaryFromServer() {
        $scope.renewalSummaryRequestPromise = RenewalService.getRenewalSummary($stateParams.renewalNumber).then(function (renewalSummary) {
            $scope.renewalSummary = renewalSummary;
        }, function () {});
    }

    $scope.$on('notesUpdated', function () {
        updateSummaryFromServer();
    });

    $scope.$on('documentsUpdated', function () {
        updateSummaryFromServer();
    });

    $scope.$on('activitiesUpdated', function () {
        updateSummaryFromServer();
    });

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', 'lobConfig', '$window', '$q', '$stateParams', 'RenewalService', 'ActivityService', '$modal', 'ModalService', '$filter', 'UserService', '$translate', 'InsuranceSuiteMetadata', 'defaultLocaleDetails', 'GPA_PC_ENTRY_POINT'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/RenewalDetailCtrl.js
// module id = 1686
// module chunks = 0